export interface QuestionHistoryEntry {
  fieldId: string;
  selected: string[];
}

export interface HistoryState {
  answers: Record<string, string[]>;
  questionHistory: QuestionHistoryEntry[];
}

export class HistoryManager {
  static reconstructAnswersFromHistory(history: QuestionHistoryEntry[]): Record<string, string[]> {
    const answers: Record<string, string[]> = {};
    for (const entry of history) {
      if (entry.selected.length > 0) {
        answers[entry.fieldId] = entry.selected;
      }
    }
    return answers;
  }

  static addAnswer(
    currentHistory: QuestionHistoryEntry[],
    fieldId: string,
    selected: string[]
  ): QuestionHistoryEntry[] {
    return [...currentHistory, { fieldId, selected }];
  }

  static removeLastAnswer(history: QuestionHistoryEntry[]): QuestionHistoryEntry[] {
    return history.slice(0, -1);
  }

  static getCurrentQuestion(history: QuestionHistoryEntry[]): QuestionHistoryEntry | null {
    return history.length > 0 ? history[history.length - 1] : null;
  }

  static isValidForQuestion(entry: QuestionHistoryEntry | null, fieldId: string): boolean {
    return entry !== null && entry.fieldId === fieldId;
  }
}
